import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  card: {
    background: theme.palette.background.paper,
    borderRadius: 8,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1)
  },
  name: {
    fontWeight: 600,
    overflowWrap: 'anywhere'
  },
  status: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1)
  },
  figures: {
    display: 'grid',
    // Two, not four: applied and in-flight are the comparison. Splitting count and money into
    // separate columns as well would put four narrow columns back on the viewport this file
    // exists to serve.
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(2)
  },
  label: {
    color: theme.palette.text.secondary
  },
  empty: {
    padding: theme.spacing(4, 2),
    textAlign: 'center',
    color: theme.palette.text.secondary
  }
}))

export default useStyles
